export const formatCode = (code: string | undefined) => {
  if (code) return code.replace(/\D/g, '').slice(0, 6);

  return '';
};
